module.exports = __webpack_public_path__ + "static/media/moneyNew.ab0b1226.svg";